// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__dYSEv","icon":"style_icon__1tJbf"};